import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';


declare var $:any;
declare var iziToast:any;

declare var $:any;

@Component({
  selector: 'app-checkout-shipping-page',
  templateUrl: './checkout-shipping-page.component.html',
  styleUrls: ['./checkout-shipping-page.component.css']
})
export class CheckoutShippingPageComponent implements OnInit {
 
  pageName = "Checkout / Shipping Details";
  modelForm: FormGroup;

  localModelDataStorage = false;
  modelName = 'Order';
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;
  shippingMethods = []
  loading = false
  shippingMethodsReady = false
  cartItems
  numberOfItems
  shippingCostReady = false;

  defaultShippingCourierCost = 0.0;
  shippingCostValue = 0.0;
  parcelId = 0;
  waybillId = 0;
  quoteId = 0;

  defaultPickUpId = 9999999;
  defaultRtpId = 1999999;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService
  ) {

      $('#loader').show();
      
   }

  ngOnInit() {

    $('#initialise-page').trigger('click');

    this.modelForm = this.formBuilder.group({
      shippingmethod: ['courier', Validators.required], 

    });

    let cartItems = localStorage.getItem("cartItems")
    
    if(cartItems) {
      this.cartItems = JSON.parse(localStorage.getItem("cartItems"))
      this.numberOfItems = this.cartItems.length

      let currentOrder = sessionStorage.getItem('order')
      if(currentOrder && parseInt(currentOrder) > 0) {
        this.modelId = currentOrder
        this.getOrderDetails()
        // this.getShippingMethods()

        //this.getCourierCost('') 
        this.createOrderDeliveryCost()
      }

    }

    else {
      //we need to send you back to checkout first page, so we can create an order for you
      let h = {
        class: "iziToast-warning",
        title:  "Order:",
        message:  "We need to capture you billing details first!",
        animateInside: !1,
        position: "topRight",
        progressBar: !1,
        icon: "icon-bell",
        timeout: 3200,
        transitionIn: "fadeInLeft",
        transitionOut: "fadeOut",
        transitionInMobile: "fadeIn",
        transitionOutMobile: "fadeOut",
      };
      iziToast.show(h);

      this.router.navigate(['/shop/checkout/address']);

    }
    
  }

  getOrderDetails() {
    let queryData = new FormData();
    queryData.append('modelName', 'Order');
    queryData.append('mid', this.modelId);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {
          this.modelData = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities'];
        },
        error => {

            $('#loader').hide();

        },

        () => {
          this.prepopulate();
          $('#loader').hide();
        }
      );
  }

  getShippingMethods() {
    let queryData = new FormData();
    queryData.append('modelName', 'ShippingMethod');

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {
          this.shippingMethods = data['covers'];

          for (let index = 0; index < this.shippingMethods.length; index++) {
            const shippingMethod = this.shippingMethods[index]['cover']['model']['modelData']['formFieldsEntities'];

            let cartTotalBreakDown = this._ecomm.calculateCartTotal()

            let shippingInfo = {
              outofbounds : false,
              crossborder: false,
              distanceKm: 25,
            }

            let totalCost = this._ecomm.calculateShippingMethodRateForShoppingCart(this.cartItems, shippingMethod, cartTotalBreakDown['total'], shippingInfo)
            this.shippingMethods[index]['cover']['cartCost'] = totalCost
          }

          this.shippingMethodsReady = true;
        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
        }
      );
  }

  //returns just a quote and the quote Id for the provided items and create a quote seperatly
  getCourierCost(shippingMethodId) {

    $('#loader').show();

    let cartdata = {
      methodId: shippingMethodId,
      items: this.cartItems
    }

    this._data.dynamicFormPost(cartdata, 'courier-get-quote') 
       .pipe(first())
       .subscribe(
         data => {
           console.log(data);

            // alert(data['quote']['methodId']['fee']);
            this.defaultShippingCourierCost = data['quote']['shippingCost'];
            this.shippingCostReady = true;
            this.shippingCostValue = this.defaultShippingCourierCost;

            if(data['quote']['id'] != undefined) {
              this.quoteId = data['quote']['id'];
            }

         },
         error => {
            $('#loader').hide();
         },

         () => {
            $('#loader').hide();
         }
     );
  }

  //create a quote and attaches it to the Order
  createOrderDeliveryCost() {
    let queryData = new FormData();
    queryData.append('id', this.modelId);

    this._data.dynamicFormPost(queryData, 'order-create-shipping-cost') 
       .pipe(first())
       .subscribe(
         data => {
           console.log(data);

            // alert(data['quote']['methodId']['fee']);
            this.defaultShippingCourierCost = data['quote']['shippingCost'];
            this.shippingCostReady = true;
            this.shippingCostValue = this.defaultShippingCourierCost;

         },
         error => {
            $('#loader').hide();
         },

         () => {
            $('#loader').hide();
         }
     );
  }

  onSubmit() {

    //alert('working magic!')
    $('#buttonText').text('Please Wait...');
    $('#loader').show();
    

    let shipping = $( "[name=shippingmethod]" ).val();

    if(shipping != "")
    {
      this.createModel(); // run combine function
    }

    else {
      $('#buttonText').text('Continue ');
      $('#loader').hide();
    }
  
  }

  updateShippingMethodCost(index) {

    if(index > 0 && index == this.defaultPickUpId) {
      this.shippingCostValue = 0;
    }

    else if(index > 0 && index == this.defaultRtpId) {
      this.shippingCostValue = this.defaultShippingCourierCost
    }

    else if(index > 0 && this.shippingMethods[index] != undefined) {
      this.shippingCostValue = this.shippingMethods[index]['cover']['cartCost']
    }

    else {
      this.shippingCostValue = this.defaultShippingCourierCost
    }
    
  }

  toggleCourierOptions() {

    let shipping = $( "[name=shippingmethod]" ).val();

    if(shipping && shipping != "")
    {
      switch (shipping) {

        case 'default-courier':

          this.shippingCostValue = this.shippingCostValue;
          
          break;

        case 'local-pickup':
  
          this.shippingCostValue = 0;
          
          break;
      
        default:
          break;
      }
    }
  }

  prepopulate(){
        if(this.modelData['shippingInfo']['deliveryMethod']) {
          // $( "[name=shippingmethod]" ).val(this.modelData['shippingInfo']['shipping_method']);
        }
  }

  createModel() {

    let selectedShippingMethod = $( "[name=shippingmethod]" ).val();
    let modelObject1 = new FormData();
    let cost = this.shippingCostValue+''
    modelObject1.append('modelName', 'Order');
    modelObject1.append('id', this.modelId);
    modelObject1.append('shippingInfo-totalCost', cost);
    modelObject1.append('shippingInfo-deliveryMethod', selectedShippingMethod);
    // modelObject1.append('shippingInfo-parcelId', this.modelForm.controls['last_name'].value);
    // modelObject1.append('shippingInfo-waybillId', this.modelForm.controls['phone'].value);
    modelObject1.append('shippingInfo-status', 'Pending');
    modelObject1.append('shippingInfo-qouteId', this.quoteId+'');

    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {
 
          this.returnData = data;
          console.log('this is the new model return object: '+JSON.stringify(this.returnData));

          // this.modelId = data['result']['id'];
          this.modelId = data['result']['id'];
          this.modelData = data['result'];
        },
        error => {
          console.log(error);

          $('#buttonText').text('Continue ');
          $('#loader').hide();

        },

        () => {
          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your order details updated successfuly.'
          });

          $('#buttonText').text('Continue ');
          $('#loader').hide();

          this.router.navigate(['/shop/checkout/payment']);
        }
      );
  }

}
